import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section aria-labelledby="problema" className="border-y border-ink-600 bg-ink-800" data-id="element-162" data-mp="2lm0v5d9i1cv3">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "16px"
    }} data-id="element-163" data-mp="26xehdfzist5z">
        <h2 id="problema" className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-164" data-mp="2bvy1rbygtww8">
          ¿Cuántos domingos más
          <span className="block text-court-400" data-id="element-165" data-mp="21zcyav23gtui">vas a perder así?</span>
        </h2>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-166" data-mp="21x067p2mh33q">
          Amas el pádel, pero tu tiempo libre lo gastas armando clases a cualquier hora.
          <strong className="font-semibold text-white" data-id="element-167" data-mp="1sywufkhfvkp4"> No es falta de vocación. Es falta de un sistema.</strong>
        </p>

        <p className="mt-10 text-sm font-bold uppercase tracking-[0.2em] text-slate-500" data-id="element-168" data-mp="3nco24eg7juhx">
          ¿TE SUENA FAMILIAR ALGO DE ESTO?
        </p>

        <ul className="mt-6 divide-y divide-ink-600 border-y border-ink-600" data-id="element-169" data-mp="1yzn5vpjpviiq">
          {painPoints.map(point => <li key={point} className="flex gap-4 py-4" data-id="element-170" data-mp="1u0smomhu7ry3">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" aria-hidden="true" data-id="element-171" data-mp="27sqqchss4vmv" />
              <span className="text-[15px] leading-relaxed text-slate-300" data-id="element-172" data-mp="23rdik264midb">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}